import { SporsmalType, SvarId } from '../../types/generated-types';
import { CurrentSporsmal } from '../reducer/current-steg';
import { Radiosporsmal } from '../reducer/sporsmalsflyt-types';

export interface CurrentRadiosporsmal {
    type: SporsmalType.Radio;
    sporsmal: Radiosporsmal;
    svarId?: SvarId;
}

export interface BesvartRadiosporsmal {
    type: SporsmalType.Radio;
    sporsmal: Radiosporsmal;
    svarId: SvarId;
}

export const isRadioSporsmal = (besvartSporsmal: CurrentSporsmal): besvartSporsmal is CurrentRadiosporsmal =>
    besvartSporsmal.type === SporsmalType.Radio;
